import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VSimpleTable, {
    staticClass: "domainTable",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('tbody', _vm._l(_vm.domains, function (item) {
          return _c('tr', {
            key: item
          }, [_c('td', [_vm._v(_vm._s(item))]), _c('td', {
            attrs: {
              "width": "40"
            }
          }, [_c(VIcon, {
            attrs: {
              "small": "",
              "color": _vm.color
            },
            on: {
              "click": function ($event) {
                return _vm.deleteDomain(item);
              }
            }
          }, [_vm._v("fa fa-trash-alt")])], 1)]);
        }), 0), _c('tfoot', [_c('tr', [_c('td', {
          staticClass: "px-0"
        }, [_c(VTextField, {
          attrs: {
            "outlined": _vm.inpOutlined,
            "filled": _vm.inpFilled,
            "color": _vm.color,
            "dense": "",
            "hide-details": ""
          },
          on: {
            "focus": _vm.clearError
          },
          model: {
            value: _vm.domainInput,
            callback: function ($$v) {
              _vm.domainInput = $$v;
            },
            expression: "domainInput"
          }
        })], 1), _c('td', {
          attrs: {
            "width": "40"
          }
        }, [!_vm.isDomainCheckBusy ? _c(VIcon, {
          attrs: {
            "small": "",
            "color": _vm.color
          },
          on: {
            "click": function ($event) {
              return _vm.addDomain();
            }
          }
        }, [_vm._v("fa fa-plus")]) : _vm._e(), _vm.isDomainCheckBusy ? _c(VProgressCircular, {
          attrs: {
            "size": 24,
            "width": 3,
            "indeterminate": "",
            "color": _vm.color
          }
        }) : _vm._e()], 1)]), _vm.errorMessage ? _c('tr', [_c('td', {
          attrs: {
            "colspan": "2"
          }
        }, [_c('p', {
          staticClass: "ma-0 danger--text"
        }, [_vm._v(_vm._s(_vm.errorMessage))])])]) : _vm._e()])];
      },
      proxy: true
    }])
  }), _c('p', {
    staticClass: "info-text"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.tenant.domainInfoText')))])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };